var StateArgument = /** @class */ (function () {
    function StateArgument(arg) {
        this.value = arg;
    }
    StateArgument.prototype.resolve = function (controlModel, contextEntity, parentFieldFinder) {
        if (controlModel.properties &&
            controlModel.properties.generalProperties) {
            return controlModel.properties.generalProperties.get(this.value, 'undefined');
        }
        else {
            throw Error(controlModel.selector + " has no properties");
        }
    };
    return StateArgument;
}());
export { StateArgument };
//# sourceMappingURL=state-argument.js.map